"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SectionRow = function SectionRow(_ref) {
  var children = _ref.children,
      border = _ref.border,
      size = _ref.size,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(StyledSectionRow, {
    border: border,
    size: size,
    className: className
  }, children);
};

var Section_v2 = function Section_v2(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      otherProps = _objectWithoutProperties(_ref2, ["children", "className"]);

  return /*#__PURE__*/_react.default.createElement(StyledSection, _extends({}, otherProps, {
    className: className
  }), children);
};

var StyledSection = _styledComponents.default.div.withConfig({
  displayName: "StyledSection"
})(["padding:2.4rem 3.6rem;margin-top:2rem;position:relative;background:white;border:1px solid #e4e4e4;box-sizing:border-box;box-shadow:0 6px 16px rgba(181,181,181,0.25);border-radius:5px;width:100%;max-width:100rem;"]);

var StyledSectionRow = _styledComponents.default.div.withConfig({
  displayName: "StyledSectionRow"
})(["width:100%;display:flex;align-items:flex-start;justify-content:space-between;flex-wrap:wrap;border-bottom:", ";padding-bottom:1.6rem;margin-bottom:1.6rem;> *{flex:0 0 ", ";margin:5px 0;}&:last-child{margin-bottom:0;padding-bottom:0;}"], function (_ref3) {
  var border = _ref3.border;
  return border ? '1px solid #e4e4e4' : '';
}, function (_ref4) {
  var size = _ref4.size;
  return size === 'three' ? '31.5%' : size === 'two' ? '47.5%' : '100%';
});

Section_v2.propTypes = {
  children: _propTypes.node,
  className: _propTypes.string,
  otherProps: _propTypes.object
};
Section_v2.defaultProps = {
  otherProps: {}
};
SectionRow.propTypes = {
  children: _propTypes.node.isRequired,
  className: _propTypes.string,

  /** Pass "one", "two" or "three" to choose the amount of columns in the row. */
  size: _propTypes.string,

  /** Pass this prop to add a border at the bottom of the row. */
  border: _propTypes.bool
};
Section_v2.Row = SectionRow;
Section_v2.Row.displayName = 'Section_v2.Row';
var _default = Section_v2;
exports.default = _default;